"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctHSV = correctHSV;
var consts_1 = require("./consts");
var clamp_1 = require("./clamp");
/** Corrects an HSV color to fall within the valid range. */
function correctHSV(color) {
    return {
        h: (0, clamp_1.clamp)(color.h, consts_1.MAX_COLOR_HUE),
        s: (0, clamp_1.clamp)(color.s, consts_1.MAX_COLOR_SATURATION),
        v: (0, clamp_1.clamp)(color.v, consts_1.MAX_COLOR_VALUE),
    };
}
//# sourceMappingURL=correctHSV.js.map